import { convertToDecimals, currency, IProfessionalInvoiceBookings, ProfessionalReplacementTypes } from '@pharmaplan/common';

import { MomentTimeFormats } from '../../../helpers/Constants';
import { getDateTimeDiff } from '../../Modals/WorkshiftDetails/utils';
import { getDayMonthDateYear } from '../../Reports/helpers';
import { IInvoiceStateBookings } from '../InvoiceLayout/InvoiceLayout';
import strings from '../../../localization';

export enum InvoiceCellType {
  text = 'text',
  timePicker = 'timePicker',
  remove = 'remove'
}

export interface IInvoiceTableHeader {
  key: number | string;
  label: string;
}

export interface IInvoiceTableRowData {
  key: string | number;
  value: string | number;
  type?: InvoiceCellType;
  invoiced?: boolean;
}

export interface IInvoiceTableRow {
  key: string | number;
  data: Array<IInvoiceTableRowData>;
}

export interface IInvoiceTableObj {
  headers: Array<IInvoiceTableHeader>;
  rows: Array<IInvoiceTableRow>;
}

export interface IInvoiceTable {
  table: IInvoiceTableObj;
  setInvoiceState: React.Dispatch<
    React.SetStateAction<Record<string, IInvoiceStateBookings>>
  >;
  invoiceState: Record<string, IInvoiceStateBookings>;
  handleRemoveBooking: (id: string) => () => void;
}

export const tableHeader = [
  {
    key: 0,
    label: 'Date',
  },
  {
    key: 1,
    label: 'Service',
  },
  {
    key: 2,
    label: 'De/From',
  },
  {
    key: 3,
    label: 'À/To',
  },
  {
    key: 4,
    label: 'Total Hours',
  },
  {
    key: 5,
    label: 'Taux/Rate',
  },
  {
    key: 6,
    label: 'Total',
  },
];

export const tableRow = ({ data, invoiceState }: { data: Array<IProfessionalInvoiceBookings>, invoiceState: Record<string, IInvoiceStateBookings> }) =>
  data.map((item) => {
    const date = getDayMonthDateYear(item.startDate);
    const { startDate, endDate } = invoiceState?.[item.bookingId] ?? {};
    const totalHours = getDateTimeDiff(startDate, endDate);
    const { typeReplacement, invoiced } = item ?? {};

    const labels = {
      [ProfessionalReplacementTypes.pharmacist]: strings.reliefPharmacist,
      [ProfessionalReplacementTypes.technician]: strings.reliefTechnician,
      [ProfessionalReplacementTypes.student]: strings.reliefStudent,
    };

    const serviceLabel = labels[typeReplacement ?? ProfessionalReplacementTypes.pharmacist];
    const total = `${currency}${convertToDecimals(item.paidHourlyRate * totalHours)}`;

    return ({
      key: item.bookingId,
      data: [
        { key: '1', value: `${date}`, type: InvoiceCellType.remove, invoiced },
        {
          key: '2',
          value: serviceLabel,
        },
        {
          key: 'startDate',
          value: startDate?.toFormat?.(MomentTimeFormats.hrMinute),
          type: InvoiceCellType.timePicker,
        },
        {
          key: 'endDate',
          value: endDate?.toFormat?.(MomentTimeFormats.hrMinute),
          type: InvoiceCellType.timePicker,
        },
        {
          key: '5',
          value: totalHours ?? 0,
        },
        {
          key: '6',
          value: item.paidHourlyRate,
        },
        {
          key: '7',
          value: total,
        },
      ],
    });
  });
